<template>
    <div id="task-settings">
        <a-tabs v-model:activeKey="activeTab">
            <a-tab-pane key="workflow" :tab="$t('task.workflow')"><Workflow /></a-tab-pane>
            <a-tab-pane key="description" :tab="$t('message.description')">
                <div class="settings-description">
                    {{ $t("task.settingsDesc1") }}
                    <br />
                    <br />
                    {{ $t("task.settingsDesc2") }}
                    <br />
                    <br />
                    {{ $t("task.settingsDesc3") }}
                    <br />
                    <br />
                    {{ $t("task.settingsDesc4") }}
                </div>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>
<script>
import { mapState } from "vuex";
import Workflow from "./Workflow.vue";
export default {
    name: "TaskSettings",
    components: {
        Workflow,
    },
    data: () => ({
        activeTab: "workflow",
        form: {
            title: null,
            description: null,
            pipelines: [],
        },
    }),
    computed: {
        ...mapState({
            users: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc.push({
                        value: user._id,
                        label: user.name,
                    });
                    return acc;
                }, []),
        }),
    },
    methods: {},
    mounted() {},
    watch: {
        form: {
            deep: true,
            handler() {
                this.$emit("update-form", this.form);
            },
        },
    },
};
</script>
<style lang="scss">
#task-settings {
    .ant-tabs-ink-bar {
        background-color: #ec4b1d;
    }
    .ant-tabs-nav .ant-tabs-tab-active {
        color: #ec4b1d;
    }
    .ant-tabs-nav .ant-tabs-tab:hover {
        color: #ec4b1d;
    }
    .ant-tabs-nav .ant-tabs-tab {
        margin-right: 6px;
        padding: 8px 16px;
    }

    .settings-description {
        font-size: 15px;
    }
}
</style>
